import React, { Component } from 'react'
import { Row, Col, Table, Icon, Popconfirm } from 'antd'
import { Link } from 'react-router-dom'

class AdminRoles extends Component {

    render() {
        const columns = [{
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'Nome',
            dataIndex: 'rolename',
            key: 'rolename'
        },
        {
            title: 'Opções',
            key: 'action',
            render: (text, record) => {
                if (record.sysname === 'public') return null
                else return (
                    <span>
                        <Link to={'/admin/roles/form/' + record.id}>
                            <Icon type="edit" style={{color: 'green'}} />
                        </Link>
                        <span className="ant-divider" />
                        <Popconfirm title="Confirma DESTRUIR o perfil?"
                            onConfirm={(e) => this.props.remove(record)}
                            okText="Sim" cancelText="Não">
                            <a role="button">
                                <Icon type="delete" style={{color: 'red'}} />
                            </a>
                        </Popconfirm>
                    </span>
                )
            }
        }]
        this.props.items.map((item) => {
            item.key = item.id
            return item
        })
        return (
            <Row>
                <Col span={24}>
                    <Link to={'/admin/roles/form'} style={{float: 'right'}}>
                        <Icon type="edit" /> Novo Perfil
                    </Link>
                    <br />
                    <hr style={{clear: 'both'}} />
                    <Table dataSource={this.props.items} columns={columns} />
                </Col>
            </Row>
        )
    }
}

export default AdminRoles;



// WEBPACK FOOTER //
// ./src/components/AdminRoles.js